import {
	CommonFeatureAppConfig,
	defaultCommonFeatureAppConfig,
	useFeatureAppEnvironment
} from '../context/feature-app-env.context';

export function createModelOverviewFeatureAppConfig(
	config: Partial<CommonFeatureAppConfig> = {}
): CommonFeatureAppConfig {
	return {
		...defaultCommonFeatureAppConfig,
		...config
	};
}

export function useFeatureAppConfig(): CommonFeatureAppConfig {
	return useFeatureAppEnvironment().config;
}
